import React from 'react';
import List from '../../../containers/rest/List';
import RestFieldItem from '../../../components/RestField/RestFieldItem';
import ActionGroup from '../../../components/RestActions/ActionGroup';
import EditButton from '../../../components/RestActions/EditButton';
import DeleteButton from '../../../components/RestActions/DeleteButton';

const CustomerSegmentationsList = props => (
  <List {...props} isScroll={false} resource="customerSegmentations">
    <RestFieldItem source="name" header="customerSegmentations.name" />
    <RestFieldItem source="description" header="customerSegmentations.description" />
    <ActionGroup>
      <EditButton />
      <DeleteButton isSortDelete />
    </ActionGroup>
  </List>
);

CustomerSegmentationsList.propTypes = {};

export default CustomerSegmentationsList;
